module.exports = __webpack_public_path__ + "static/media/add.723b69f6.png";